import React from 'react'
import {
  Box,
  TopoBox,
  BoxSplash,
  BoxSplashText,
  BoxSplashDiscount,
  TopoBoxFlex,
  TagPlanoAtual,
  TagPlano,
  TituloPlano,
  TipoPlano,
  TituloLista
} from './Styled'

import icSplash from 'images/icons/ic-splash.svg'

/* Componentes */
import Bonus from './Components/Bonus/Bonus'
import List from './Components/List/List'
import Cartao from './Components/Cartao/Cartao'
import Boleto from './Components/Boleto/Boleto'

export default function Plano ({ dadosPlano, atual, tipo, lote, basica, bonus }) {    

    const editTitle = (title) => {
        let newTitle = title.split(" - ")
        return newTitle[0]
    }    

    return (
        <Box>
        
            {/* Box Topo */}
            <TopoBox atual={atual} className={ basica ? 'basica' : '' }>

                <TopoBoxFlex>

                    {/* Tag */}
                    { atual ? <TagPlanoAtual>Este é o seu plano atual</TagPlanoAtual> : <TagPlano tipo={dadosPlano.tag === 'Faça upgrade com a melhor oferta' ? 1 : 2} className={ basica ? 'basica' : '' }>Renove seu plano com desconto</TagPlano> }

                    {/* Título do Plano */}
                    <TituloPlano atual={atual} dangerouslySetInnerHTML={{ __html: editTitle(dadosPlano.nome) }} />

                    {/* Tipo do Plano */}
                    {dadosPlano.plano ? <TipoPlano atual={atual}>{dadosPlano.plano}</TipoPlano> : null}
                    
                    {/* Bônus */}
                    { !atual ? 
                        bonus.map((bonus, index) => {
                            return <TipoPlano key={index}>{bonus}</TipoPlano>
                        })
                    : null }

                </TopoBoxFlex>

                { !atual 
                ? <BoxSplash bg={icSplash}>
                    <BoxSplashDiscount>{dadosPlano.boleto.desconto}%</BoxSplashDiscount>
                    <BoxSplashText>off</BoxSplashText>
                    </BoxSplash> 
                : null 
                }

            </TopoBox>

            {/* Lista de Bônus */}
            { !atual && lote === 1 ? <Bonus /> : null }
            
            {/* Título das Vantagens */}
            { !atual ? <TituloLista>O que faz parte da assinatura:</TituloLista> : null }

            {/* Lista de Vantagens */}
            {dadosPlano.vantagens && !atual ? <List itens={dadosPlano.vantagens} /> : null}

            {/* Cartão */}
            {dadosPlano.cartao ? <Cartao tipo={tipo} dados={dadosPlano.cartao} /> : null}

            {/* Boleto */}
            {dadosPlano.boleto ? <Boleto tipo={tipo} dados={dadosPlano.boleto} /> : null}
        
        </Box>
    )
}
